<template>
  <div class="container">
    <div :class="['service-category', {'service-category--fromMain': fromMain}]">
      <div class="service-category__inner">
        <div class="service-category__header">
          <div class="service-category__back">
            <Back
              :title="t('pay_serivces')"
              :redirect="redirect"
              :vertical="isDefault"
              :showIcon="!fromMain"
            />
          </div>
          <div class="service-category__search">
            <ap-search
              :placeholder="t('services.search_placeholder')"
              @input="filter"
            />
          </div>
        </div>
        <ap-loader v-if="loading"/>
        <div
          v-else
          class="service-category__body"
        >
          <div v-if="!catalogsList.length">Не найдено</div>
          <div
            v-else
            class="sc-grid"
          >
            <div class="sc-grid__inner">
              <div
                v-for="catalog in catalogsList"
                :key="catalog.id"
                class="sc-grid__item"
              >
                <router-link :to="{ name: routeName, params: { id: catalog.id, name: catalog.name, fromMain: fromMain }}">
                  <div :class="['sc-card', {'sc-card--service': isService }]" >
                    <div class="sc-card__inner">
                      <div class="sc-card__icon">
                        <img
                          :src="catalog.icon || catalog.image"
                          alt="icon"
                        >
                      </div>
                      <div class="sc-card__text">
                        {{ catalog.name }}
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, onBeforeMount, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

import apSearch from '@/components/UI/apSearch.vue';
import apLoader from '@/components/UI/apLoader.vue';

import Back from '@/components/Back.vue';

export default defineComponent({
  name: 'ServiceCategoryView',
  components: {
    Back,
    apSearch,
    apLoader
  },
  props: {
    fromMain: {
      type: Boolean,
      default: false
    }
  },

  setup(props) {
    const store = useStore();
    const { t } = useI18n();
    const searchText = ref('');
    const isService = ref(false);
    const loading = ref(false);
    const isDefault = computed(() => store.getters['isDefault']);
    const language = computed(() => store.getters['language']);
    const routeName = computed(() => isService.value ? 'service-pay' : 'service-list');
    const redirect = computed(() => props.fromMain ? {name: '',
      text: ''} : {name: 'main',
      text: t('main')} );
    const catalogsList = computed(() =>  {
      const service = store.getters['services/services'];

      return searchText.value && searchText.value.replace(/\s/g, '').length > 0 
        ? service.services
        : service.catalogs;
    });

    const filter = (e: Event) => {
    	const element = e.target as HTMLInputElement;
    	searchText.value = element.value;
    	const validSearchText = searchText.value && searchText.value.replace(/\s/g, '').length > 0;
    	validSearchText ? (
    		isService.value = true,
        loading.value = true,
    		store.dispatch('services/searchServices', {
    			name: searchText.value,
    			language: language.value
    		}).finally(() => {
          loading.value = false;
        })
    	) : (
    		isService.value = false, store.dispatch('services/searchServices')
    	);
    };

    onBeforeMount(() => {
      store.dispatch('services/getServices', {
        language: language.value
      });
      if (props.fromMain) {
        store.commit('services/setFromMain', true);
      }
    });

    return {
      redirect,
      catalogsList,
      filter,
      isDefault,
      isService,
      routeName,
      t,
      loading,
    };
  },
});
</script>
<style lang="scss" scoped>
.service-category{
  min-height: 660px;
  height: 100%;
  padding: 40px 0 80px 0;
  &__inner{
    height: 100%;
  }
  &__back{
    margin-bottom: 16px;
  }
  &__search{
    margin-bottom: 24px;
  }
  &--fromMain{
    padding: 0;
    min-height: 440px;
  }
}
.sc-grid{
  &__inner{
    display: grid;
    grid-template-columns: repeat(5, 224px);
    gap: 28px
  }
}
.sc-card{
  background: #FFFFFF;
  border-radius: 8px;
  padding: 24px;
  width: 100%;
  height: 100%;
  &__icon{
    margin-bottom: 12px;
    img{
      max-width: 100%;
    }
  }
  &__text{
    color: $primary-blue;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
  }
}
.sc-card--service{
  .sc-card{
    &__icon{
      img{
        max-width: 40px;
        max-height: 40px;
        width: 100%;
        height: 100%;
        display: block;
        margin: 0 auto;
        filter: none;
      }
    }
    &__text{
      text-align: center;
    }
  }
}
.tele2{
  .sc-card{
    border: 1px solid $primary-white;
    &__text{
      font-family: "Open Sans";      
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      color: $tele2-primary-black;
    }
    img{
      filter: invert(42%) sepia(7%) saturate(211%) hue-rotate(202deg) brightness(88%) contrast(87%);
    }
  }
  .sc-card--service {
    img{
      filter: none;
    }
  }
  .sc-card:hover{
    border-color: $secondary-blue;
    .sc-card__text{
      color: $secondary-blue !important;
    }
    img{
      filter: invert(45%) sepia(58%) saturate(3182%) hue-rotate(170deg) brightness(93%) contrast(105%);
    }
  }

  .sc-card--service:hover{
    img{
      filter: none;
    }
  }
}
.altel{
  .sc-card{
    border: 1px solid $primary-white;
    &__text{
      font-family: "OpenSans", sans-serif;      
      font-weight: bold;
      color: $altel-primary-black;
    }
  }

  .sc-card--service {
    img{
      filter: none;
    }
  }
  .sc-card:hover{
    border-color: $primary-pink;
    .sc-card__text{
      color: $primary-pink !important;
    }
    img{
      filter: invert(13%) sepia(91%) saturate(6674%) hue-rotate(320deg) brightness(89%) contrast(104%);
    }
  }

  .sc-card--service:hover{
    border-color: $primary-white;
    .sc-card__text{
      color: $primary-white;
    }
    img{
      filter: none;
    }
    
  }
}
@media (min-width: 320px) and (max-width: 375px) {
  .sc-grid{
    &__inner{
      grid-template-columns: repeat(1, 1fr);
    }
  }
}
@media (min-width: 376px) and (max-width: 480px) {
  .sc-grid{
    &__inner{
      grid-template-columns: repeat(2, 1fr);
      gap: 12px
    }
  }
}
@media (min-width: 481px) and (max-width: 1280px) {
  .sc-grid{
    &__inner{
      grid-template-columns: repeat(auto-fill, minmax(224px, 1fr) );
      gap: 12px
    }
  }
}
</style>